<template>
  <section v-if="report && report.conditionIntro">
    <z-popup v-model="showCondition" position="bottom" class="b2c_pop-wrapper">
      <div class="pop-title">
        等级说明<img
          src="https://pic6.zhuanstatic.com/zhuanzh/1b8afb9f-426f-46dc-92b2-4cc6dcfdcce3.png"
          @click="togglePopup"
        />
      </div>
      <div class="condition-wrapper">
        <div class="condition-list">
          <div
            v-for="(item, index) in report.conditionIntro.data"
            :key="index"
            class="condition-item"
          >
            <div class="item-title">{{ item.conditionName }}</div>
            <div class="item-content">{{ item.conditionLabel }}，{{ item.conditionText }}</div>
          </div>
        </div>
      </div>
    </z-popup>
  </section>
</template>
<script>
  import Vue from 'vue'
  import { Popup } from '@zz-common/zz-ui'
  Vue.use(Popup)
  export default {
    name: 'rank-pop',
    props: {
      report: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        showCondition: false,
      }
    },
    methods: {
      togglePopup() {
        this.showCondition = !this.showCondition
      },
    },
  }
</script>

<style lang="scss">
  .b2c_pop-wrapper {
    padding-top: 24px;
    .pop-title {
      position: relative;
      height: 80px;
      line-height: 80px;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #111111;
      text-align: center;
      img {
        position: absolute;
        top: 28px;
        right: 32px;
        width: 24px;
      }
    }
    .condition-wrapper {
      padding: 24px 40px calc(60px + constant(safe-area-inset-bottom));
      padding: 24px 40px calc(60px + env(safe-area-inset-bottom));
      max-height: 70vh;
      overflow-y: scroll;
      box-sizing: border-box;
      .condition-list {
        border-radius: 12px;
        overflow: hidden;
        .condition-item {
          margin-bottom: 4px;
          display: flex;
          .item-title {
            margin-right: 4px;
            width: 140px;
            padding-top: 31px;
            text-align: center;
            background: #f8f8f8;
            font-size: 26px;
            font-family: Akrobat-ExtraBold, Akrobat;
            font-weight: 800;
            color: #111111;
            line-height: 30px;
          }
          .item-content {
            flex: 1;
            padding: 26px 40px;
            line-height: 40px;
            background: #f8f8f8;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }
        }
        .condition-item :last-child {
          margin-bottom: 0;
        }
      }
    }
  }
</style>
